import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import {
  FaArrowRight,
  FaShoppingBag,
  FaSearch,
  FaWhatsapp,
  FaTag,
  FaUserCircle,
  FaTimes,
  FaGraduationCap,
  FaTrophy,
  FaCalendarAlt,
  FaImages,
  FaMapMarkerAlt,
  FaPhoneAlt
} from 'react-icons/fa';
import { getImageUrl, productAPI } from '../services/api';
import logo from '../assets/logo.png';
import image1 from '../assets/image1.jpeg';
import './PublicStorePage.css';

const defaultProducts = [
  {
    ProductID: 8,
    ProductName: "B positive helmet ",
    Category: "Gear",
    Size: "S/M",
    UnitPrice: "1500.00",
    StockQuantity: 30,
    ImagePath: "/uploads/products/products_1776070915794-478100992.jpeg",
    RecordStatus: "Active"
  },
  {
    ProductID: 7,
    ProductName: "Be positive ( CH-1 )",
    Category: "Toy inline ",
    Size: "All size available ",
    UnitPrice: "7500.00",
    StockQuantity: 100,
    ImagePath: "/uploads/products/products_1776070696233-720746854.jpeg",
    RecordStatus: "Active"
  },
  {
    ProductID: 9,
    ProductName: "MINIMIZER Bearing ",
    Category: "Bearing ",
    Size: "",
    UnitPrice: "18000.00",
    StockQuantity: 100,
    ImagePath: "/uploads/products/products_1785752501621-637112796.jpeg",
    RecordStatus: "Active"
  },
  {
    ProductID: 5,
    ProductName: "SR DASH",
    Category: "Professional inline ",
    Size: "All size",
    UnitPrice: "58000.00",
    StockQuantity: 100,
    ImagePath: "/uploads/products/products_1776070535921-377753395.jpeg",
    RecordStatus: "Active"
  },
  {
    ProductID: 6,
    ProductName: "Viva Gold ",
    Category: "Professional skate",
    Size: "All size available ",
    UnitPrice: "25000.00",
    StockQuantity: 100,
    ImagePath: "/uploads/products/products_1776070616878-46987103.jpeg",
    RecordStatus: "Active"
  }
];

function PublicStorePage() {
  const navigate = useNavigate();
  const [products, setProducts] = useState(defaultProducts);
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [searchQuery, setSearchQuery] = useState('');
  const [theme, setTheme] = useState('dark');
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    productAPI.getAll()
      .then((res) => {
        const loaded = res.data?.data || res.data || [];
        if (Array.isArray(loaded) && loaded.length > 0) {
          setProducts(loaded);
        }
      })
      .catch((err) => {
        console.log('Error loading products from API, using default list:', err);
      });
  }, []);

  const categories = ['All', ...Array.from(new Set(products.map((p) => (p.Category ? p.Category.trim() : '')).filter(Boolean)))];

  const filteredProducts = products.filter((p) => {
    const matchesCategory = selectedCategory === 'All' || (p.Category ? p.Category.trim() : '') === selectedCategory;
    const matchesSearch = p.ProductName.toLowerCase().includes(searchQuery.toLowerCase()) ||
                          (p.Category && p.Category.toLowerCase().includes(searchQuery.toLowerCase()));
    return matchesCategory && matchesSearch;
  });

  const handleBuyInquire = (product) => {
    const formattedPrice = Number(product.UnitPrice || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 });
    const message = encodeURIComponent(`Hello Epsilon Skating Club! I am interested in purchasing "${product.ProductName}" (Price: ₹${formattedPrice}). Please share availability and order details.`);
    window.open(`https://wa.me/918871072857?text=${message}`, '_blank');
  };

  const handleNavClick = (section) => {
    setMenuOpen(false);
    navigate('/', { state: { scrollTo: section } });
  };

  return (
    <div className={`public-store-wrapper store-theme-${theme}`}>
      {/* Full Sticky Navigation Header */}
      <header className="editorial-header header-scrolled">
        <div className="header-inner">
          <Link to="/" className="brand-badge" aria-label="Epsilon Skating Club Home">
            <div className="brand-logo-shell">
              <img src={logo} alt="Epsilon Skating Club Raipur" className="brand-logo-img" />
            </div>
            <div className="brand-text-block">
              <span className="brand-name">EPSILON</span>
              <span className="brand-sub">SKATING CLUB • RAIPUR</span>
            </div>
          </Link>

          {/* Desktop Nav */}
          <nav className="desktop-nav" aria-label="Main Navigation">
            <button type="button" onClick={() => handleNavClick('about')} className="nav-item">About</button>
            <button type="button" onClick={() => handleNavClick('programs')} className="nav-item">Programs</button>
            <button type="button" onClick={() => handleNavClick('batches')} className="nav-item">Batches</button>
            <button type="button" onClick={() => navigate('/store')} className="nav-item active">Products</button>
            <button type="button" onClick={() => handleNavClick('gallery')} className="nav-item">Gallery</button>
            <button type="button" onClick={() => handleNavClick('contact')} className="nav-item">Contact</button>
          </nav>

          {/* Nav Actions */}
          <div className="header-actions">
            <button
              type="button"
              className="profile-nav-btn"
              onClick={() => navigate('/login')}
              aria-label="User Profile & Login"
              title="User Login"
            >
              <FaUserCircle className="profile-btn-icon" />
              <span className="profile-btn-label">Login</span>
            </button>

            <button
              type="button"
              className={`hamburger-btn ${menuOpen ? 'is-open' : ''}`}
              onClick={() => setMenuOpen(!menuOpen)}
              aria-label="Toggle mobile menu"
            >
              <span className="ham-line ham-line-1" />
              <span className="ham-line ham-line-2" />
            </button>
          </div>
        </div>
      </header>

      {/* MOBILE NAVIGATION DRAWER */}
      <AnimatePresence>
        {menuOpen && (
          <motion.div
            className="mobile-drawer-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setMenuOpen(false)}
          >
            <motion.div
              className="mobile-drawer-panel"
              initial={{ x: '100%' }}
              animate={{ x: 0 }}
              exit={{ x: '100%' }}
              transition={{ type: 'spring', damping: 25, stiffness: 220 }}
              onClick={(e) => e.stopPropagation()}
            >
              <div className="drawer-header">
                <div className="brand-badge">
                  <img src={logo} alt="Logo" className="brand-logo-img" />
                  <span className="brand-name">EPSILON SKATING</span>
                </div>
                <button type="button" className="drawer-close" onClick={() => setMenuOpen(false)}>
                  <FaTimes />
                </button>
              </div>

              <div className="drawer-links">
                <button type="button" onClick={() => handleNavClick('about')}>
                  <FaGraduationCap className="drawer-link-icon" />
                  <span>About Academy</span>
                </button>
                <button type="button" onClick={() => handleNavClick('programs')}>
                  <FaTrophy className="drawer-link-icon" />
                  <span>Training Programs</span>
                </button>
                <button type="button" onClick={() => handleNavClick('batches')}>
                  <FaCalendarAlt className="drawer-link-icon" />
                  <span>Batches & Schedule</span>
                </button>
                <button type="button" onClick={() => { setMenuOpen(false); navigate('/store'); }}>
                  <FaShoppingBag className="drawer-link-icon" />
                  <span>Products Store</span>
                </button>
                <button type="button" onClick={() => handleNavClick('gallery')}>
                  <FaImages className="drawer-link-icon" />
                  <span>Visual Gallery</span>
                </button>
                <button type="button" onClick={() => handleNavClick('contact')}>
                  <FaMapMarkerAlt className="drawer-link-icon" />
                  <span>Contact & Map</span>
                </button>
              </div>

              <div className="drawer-ctas">
                <button type="button" className="btn-editorial-primary btn-full" onClick={() => { setMenuOpen(false); navigate('/login'); }}>
                  Member Login <FaArrowRight />
                </button>
              </div>

              <div className="drawer-contact-info">
                <p><FaMapMarkerAlt /> Raipur, Chhattisgarh</p>
                <p><FaPhoneAlt /> +91 8871072857</p>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      {/* Hero Banner */}
      <section className="store-hero">
        <div className="store-container">
          <h1 className="store-hero-title">
            Epsilon Pro Skating <span className="store-serif-accent">Equipment Store.</span>
          </h1>
          <p className="store-hero-desc">
            Explore professional speed skates, helmets, bearings, inline boots, and gear tested and approved for competitive skaters in Raipur & Chhattisgarh.
          </p>

          {/* Search Bar */}
          <div className="store-search-box">
            <FaSearch className="search-icon" />
            <input
              type="text"
              placeholder="Search gear, skates, bearings, helmets..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
        </div>
      </section>

      {/* Filter & Product List Grid */}
      <section className="store-catalog-section">
        <div className="store-container">
          {/* Category Filter Pills */}
          <div className="store-category-bar">
            {categories.map((cat) => (
              <button
                key={cat}
                type="button"
                className={`store-cat-btn ${selectedCategory === cat ? 'active' : ''}`}
                onClick={() => setSelectedCategory(cat)}
              >
                {cat}
              </button>
            ))}
          </div>

          {/* Products Count Info */}
          <div className="store-meta-bar">
            <span>Showing <strong>{filteredProducts.length}</strong> products</span>
          </div>

          {/* Products Grid */}
          <div className="store-grid">
            {filteredProducts.map((product) => {
              const imageSrc = product.ImagePath ? getImageUrl(product.ImagePath) : image1;
              const formattedPrice = `₹ ${Number(product.UnitPrice || 0).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`;

              return (
                <div key={product.ProductID} className="store-product-card">
                  <div className="store-img-shell">
                    <img
                      src={imageSrc}
                      alt={product.ProductName}
                      loading="lazy"
                      onError={(e) => { e.target.src = image1; }}
                    />
                  </div>
                  <div className="store-card-body">
                    <h3 className="store-product-name">{product.ProductName}</h3>
                    {product.Size && <p className="store-product-size"><FaTag /> Size: {product.Size}</p>}
                    <div className="store-card-footer">
                      <span className="store-product-price">{formattedPrice}</span>
                      <button
                        type="button"
                        className="btn-store-buy"
                        onClick={() => handleBuyInquire(product)}
                      >
                        <FaWhatsapp /> <span>Buy Now</span>
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          {filteredProducts.length === 0 && (
            <div className="store-empty-state">
              <FaShoppingBag className="empty-icon" />
              <h3>No Products Found</h3>
              <p>Try searching for a different item or select another category filter.</p>
            </div>
          )}
        </div>
      </section>

      {/* Footer */}
      <footer className="store-footer">
        <div className="store-container">
          <div className="store-footer-content">
            <p>© {new Date().getFullYear()} Epsilon Skating Club • Raipur, Chhattisgarh. All rights reserved.</p>
            <p>For custom bulk orders or gear inquiries, contact: +91 8871072857</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default PublicStorePage;
